"use strict";
import { tns } from "tiny-slider";

export default function () {
    if (window.innerWidth < 1024) {
        const sliders = document.querySelectorAll(".o-gallery__grid");
        if (!sliders.length) return;

        sliders.forEach((container) => {
            const slider = tns({
                container: container,
                items: 1,
                slideBy: 1,
                controls: false,
                nav: false,
                gutter: 12,
                loop: true,
                touch: true,
                mouseDrag: true,
                responsive: {
                    680: {
                        items: 2,
                        gutter: 24,
                    },
                    768: {
                        items: 3,
                    },
                },
            });

            const parent = container.closest(".o-gallery") || document;
            const arrowLeft = parent.querySelector(".arrows-left");
            const arrowRight = parent.querySelector(".arrows-right");

            if (arrowLeft) {
                arrowLeft.addEventListener("click", () => {
                    slider.goTo("prev");
                });
            }
            if (arrowRight) {
                arrowRight.addEventListener("click", () => {
                    slider.goTo("next");
                });
            }
        });
    }
}
